import { DefaultTheme } from 'styled-components';

import { VALID_THEMES } from '../StyledComponents';
import {
  default as AvantTheme,
} from '../StyledComponents/Theme/index.avant';
import {
  default as EloanTheme
} from '../StyledComponents/Theme/index.eloan';
import {
  default as HSBCTheme
} from '../StyledComponents/Theme/index.hsbc';
import {
  default as RegionsTheme
} from '../StyledComponents/Theme/index.regions';
import {
  default as TDTheme
} from '../StyledComponents/Theme/index.td';
import {
  default as PNCTheme
} from '../StyledComponents/Theme/index.pnc';
import {
  default as SynovusTheme
} from '../StyledComponents/Theme/index.synovus';
import {
  default as AmountTheme
} from '../StyledComponents/Theme/index.amount';
import {
  default as AmountDarkTheme
} from '../StyledComponents/Theme/index.amountDark';
import {
  default as BbvaTheme
} from '../StyledComponents/Theme/index.bbva';
import {
  default as CofTheme
} from '../StyledComponents/Theme/index.cof';
import {
  default as BarclaysTheme
} from '../StyledComponents/Theme/index.barclays';
import {
  default as CatalystTheme
} from '../StyledComponents/Theme/index.catalyst';
import {
  default as GuaranteedRateTheme
} from '../StyledComponents/Theme/index.guaranteed-rate';
import {
  default as JeniusTheme
} from '../StyledComponents/Theme/index.jenius';

export const themeMap: { [theme in VALID_THEMES]: DefaultTheme } = {
  [VALID_THEMES.eloan]: EloanTheme,
  [VALID_THEMES.avant]: AvantTheme,
  [VALID_THEMES.td]: TDTheme,
  [VALID_THEMES.regions]: RegionsTheme,
  [VALID_THEMES.hsbc]: HSBCTheme,
  [VALID_THEMES.pnc]: PNCTheme,
  [VALID_THEMES.synovus]: SynovusTheme,
  [VALID_THEMES.amount]: AmountTheme,
  [VALID_THEMES.amountDark]: AmountDarkTheme,
  [VALID_THEMES.bbva]: BbvaTheme,
  [VALID_THEMES.cof]: CofTheme,
  [VALID_THEMES.barclays]: BarclaysTheme,
  [VALID_THEMES.catalyst]: CatalystTheme,
  [VALID_THEMES['guaranteed-rate']]: GuaranteedRateTheme,
  [VALID_THEMES.jenius]: JeniusTheme,
};
